// extracted by mini-css-extract-plugin
export default {"highlight":"simple-highlight_highlight__LFKFK","error":"simple-highlight_error__PjjRj","errorIcon":"simple-highlight_errorIcon__VLpsF"};